var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabbar"},[_c('div',{staticClass:"line"},[_c('div',{staticClass:"tab-list"},_vm._l((_vm.tabList),function(item,index){return _c('div',{key:index,staticClass:"tab-item",class:_vm.tabIndex == index ? 'tab-active' : '',on:{"click":function($event){return _vm.handleTab(item, index)}}},[_vm._v("\n        "+_vm._s(item.name)+"\n      ")])}),0)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74595f9a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/comm/components/match/basketball/components/BasketballMatchTabbar.vue
// module id = null
// module chunks = 